import { render, staticRenderFns } from "./mod3-4.vue?vue&type=template&id=cfad1bf8&scoped=true&"
import script from "./mod3-4.vue?vue&type=script&lang=js&"
export * from "./mod3-4.vue?vue&type=script&lang=js&"
import style0 from "./mod3-4.vue?vue&type=style&index=0&id=cfad1bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfad1bf8",
  null
  
)

export default component.exports